import { TablePublicationsListType, ApiPublicationType } from './types';
import { getTimeFromNow } from '../../helpers/date';
import { truncateText } from 'src/utils';

export const filterApiResponse = (
  data: ApiPublicationType[]
): TablePublicationsListType =>
  data.map(publication => {
    return {
      key: publication.id,
      id: publication.id,
      publication: {
        ...publication,
        title: truncateText(publication.title),
        text: truncateText(publication.text),
        isPublic: publication.public,
        targetDepartments: publication.target_departments,
        targetDistricts: publication.target_districts,
        targetTowns: publication.target_towns,
      },
      author: publication.author.name,
      createdAt: getTimeFromNow(publication.created_at, true),
    };
  });
